export default __webpack_public_path__ + "static/media/008-drilling machine.6e56e3b7.svg";